module.exports = __webpack_public_path__ + "static/img/solaris-icon.c3199d96.svg";